function whenSplideReady(callback, attempt = 0) {
  if (typeof window.Splide === 'function') return callback()
  if (attempt > 50) return
  requestAnimationFrame(() => whenSplideReady(callback, attempt + 1))
}

function setCarouselCarets(root) {
  const prevTemplate = root.querySelector('[data-carousel-caret-prev]')
  const nextTemplate = root.querySelector('[data-carousel-caret-next]')
  const prev = root.querySelector('[data-testimonial-slider-splide] .splide__arrow--prev')
  const next = root.querySelector('[data-testimonial-slider-splide] .splide__arrow--next')

  const applyCaret = (button, template) => {
    const caret = template?.content?.firstElementChild
    if (!button || !caret) return
    button.replaceChildren(caret.cloneNode(true))
  }

  applyCaret(prev, prevTemplate)
  applyCaret(next, nextTemplate)
}

function bindCarouselCaretSync(root, splide) {
  const sync = () => setCarouselCarets(root)
  ;['arrows:mounted', 'updated', 'refresh', 'resize'].forEach((event) => {
    splide.on(event, sync)
  })
}

function initTestimonialSliderRoot(root) {
  const SplideCtor = window.Splide
  if (!root || root.dataset.initialized === 'true' || typeof SplideCtor !== 'function') return
  if (root.dataset.sliderInitPending === 'true') return

  const splideEl = root.querySelector('[data-testimonial-slider-splide]')
  if (!splideEl) return

  const slideCount = splideEl.querySelectorAll('.splide__slide').length
  if (slideCount === 0) return

  root.dataset.sliderInitPending = 'true'

  try {
    const splide = new SplideCtor(splideEl, {
      type: slideCount > 1 ? 'loop' : 'slide',
      gap: '16px',
      autoWidth: true,
      perMove: 1,
      focus: 0,
      trimSpace: false,
      pagination: false,
      arrows: slideCount > 1,
      autoplay: slideCount > 1,
      interval: 4000,
      pauseOnHover: true,
      pauseOnFocus: true,
      padding: { right: '4rem' },
    })

    splide.mount()
    bindCarouselCaretSync(root, splide)
    setCarouselCarets(root)
    root.dataset.initialized = 'true'
    root._testimonialSliderSplide = splide
  } finally {
    delete root.dataset.sliderInitPending
  }
}

function initTestimonialSliders(scope = document) {
  whenSplideReady(() => {
    scope.querySelectorAll('[data-testimonial-slider]').forEach(initTestimonialSliderRoot)
  })
}

function bootTestimonialSlider() {
  initTestimonialSliders()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootTestimonialSlider)
} else {
  bootTestimonialSlider()
}

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target?.querySelector('[data-testimonial-slider]')) return
  initTestimonialSliders(event.target)
})
